module.exports = __webpack_public_path__ + "img/d6a765a.png";